import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { styles } from './Input.scss';

const cx = classNames.bind(styles);

export const InputGroup = ({ size, children }) => {
  const classes = cx('c-input-group', {
    [`c-input-group--${size}`]: size,
  });

  return <div className={classes}>{children}</div>;
};

InputGroup.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  children: PropTypes.node,
};

InputGroup.defaultProps = {
  size: 'medium',
  children: null,
};
